import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ display: $data.open ? '' : 'none' }),
    class: _normalizeClass($props.classes.concat([_ctx.$style.modalDialogComponent]))
  }, [
    ($props.closeButton === true)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass([_ctx.$style.closeButton]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.closeDialog()))
        }, " × ", 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "default")
  ], 6 /* CLASS, STYLE */))
}